import { RG_TYPE, type BuildingOrAncestor } from "@project-rouge/rg-core";
import {
  countNorthFacingUnits,
  getAmenitiesArea,
  getApartmentCategoryCounts,
  getApartmentModuleCount,
  getClearInternalHeight,
  getCommercialArea,
  getCountOfType,
  getDensityHabitableRooms,
  getDensityUnits,
  getEfficiency,
  getFacadeExternalCornerLength,
  getFacadeInternalCornerLength,
  getFireCoreCount,
  getFootprint,
  getGEA,
  getGIA,
  getGlazedFacadeArea,
  getGrossFacadeArea,
  getIndicativeFormFactor,
  getLandCoverage,
  getLevelArea,
  getLevelArrayAmenitiesArea,
  getLevelArrayApartmentCategoryCounts,
  getLevelArrayApartmentModuleCount,
  getLevelArrayClearInternalHeight,
  getLevelArrayCommercialArea,
  getLevelArrayCoreAndCorridorArea,
  getLevelArrayCountNorthFacingUnits,
  getLevelArrayEfficiency,
  getLevelArrayFFL,
  getLevelArrayGEA,
  getLevelArrayGIA,
  getLevelArrayModuleCount,
  getLevelArrayNIA,
  getLevelArrayNonResidentialArea,
  getLevelArrayResidentialEfficiency,
  getLevelArrayRoofArea,
  getLevelArrayServicesArea,
  getLevelArrayUnitToLiftCoreRatio,
  getLevelCount,
  getLiftCoreCount,
  getMaxFfl,
  getMaxHeight,
  getNIA,
  getNetFacadeArea,
  getNonResidentialArea,
  getPodiumHeightSum,
  getResidentialEfficiency,
  getResidentialLevelCount,
  getPodiumLevelCount,
  getFoundationConcreteWeight,
  getFoundationSteelWeight,
  getRgObjectsAtLevel,
  getRoofGrossFacadeArea,
  getServicesArea,
  getUnitToLiftCoreRatio,
  getWallToFloorRatio,
  getLevelArrayMetric,
} from "@project-rouge/rg-three";

export const ArchitecturalMetricsCalculator = {
  BuildingHeight: {
    Max: getMaxHeight,
  },
  Floor: {
    Max: getLevelCount,
  },
  FootPrint: {
    Total: getFootprint,
  },
  GIA: {
    Total: getGIA,
    PerLevel: getLevelArrayGIA,
  },
  GEA: {
    Total: getGEA,
    PerLevel: getLevelArrayGEA,
  },
  NIA: {
    Total: getNIA,
    PerLevel: getLevelArrayNIA,
  },

  CommercialArea: {
    Total: getCommercialArea,
    PerLevel: getLevelArrayCommercialArea,
  },
  ServiceArea: {
    Total: getServicesArea,
    PerLevel: getLevelArrayServicesArea,
  },
  AmenitiesArea: {
    PerLevel: getLevelArrayAmenitiesArea,
    Total: getAmenitiesArea,
  },
  NonResidentialArea: {
    Total: getNonResidentialArea,
    PerLevel: getLevelArrayNonResidentialArea,
  },
  ApartmentMduleQuantity: {
    Total: getApartmentModuleCount,
    PerLevel: getLevelArrayApartmentModuleCount,
  },
  ApartmentQuantity: {
    Total: (obj: BuildingOrAncestor | BuildingOrAncestor[]) =>
      getCountOfType(obj, RG_TYPE.Apartment),
    PerLevel: (obj: BuildingOrAncestor | BuildingOrAncestor[]) =>
      getLevelArrayMetric(obj, (obj, i) => getCountOfType(obj, RG_TYPE.Apartment, i)),
  },
  ModuleQuantity: {
    Total: (obj: BuildingOrAncestor | BuildingOrAncestor[]) => getCountOfType(obj, RG_TYPE.Module),
    PerLevel: getLevelArrayModuleCount,
  },
  DensityUnits: {
    Total: getDensityUnits,
  },
  DensityHabitableRooms: {
    Total: getDensityHabitableRooms,
  },
  LandCoverage: {
    Total: getLandCoverage,
  },
  ResidentialEfficiency: {
    Total: getResidentialEfficiency,
    PerLevel: getLevelArrayResidentialEfficiency,
  },
  ResidentialLevelCount: {
    Max: getResidentialLevelCount,
  },
  BuildingEfficiency: {
    Total: getEfficiency,
    PerLevel: getLevelArrayEfficiency,
  },
  Facade: {
    Total: getGrossFacadeArea,
    PerLevel: getNetFacadeArea,
  },
  GlazedFacade: {
    Total: getGlazedFacadeArea,
  },
  WallToFloorRatio: {
    Total: getWallToFloorRatio,
  },
  ClearInternalHeight: {
    Total: getClearInternalHeight,
    PerLevel: getLevelArrayClearInternalHeight,
  },
  IndicativeFormFactor: {
    Total: getIndicativeFormFactor,
  },
  UnitCategoryMix: {
    PerCategory: getApartmentCategoryCounts,
    PerLevel: getLevelArrayApartmentCategoryCounts,
  },
  Entrances: {
    Total: (obj: BuildingOrAncestor | BuildingOrAncestor[]) =>
      getCountOfType(obj, RG_TYPE.Entrance),
  },
  Cores: {
    Total: (obj: BuildingOrAncestor | BuildingOrAncestor[]) =>
      getRgObjectsAtLevel(obj, RG_TYPE.Core, 0).length,
  },
  FireCores: {
    Total: getFireCoreCount,
  },
  LiftCores: {
    Total: getLiftCoreCount,
  },
  FFL: {
    Max: getMaxFfl,
    PerLevel: getLevelArrayFFL,
  },
  CoreAndCorridorArea: {
    Total: (obj: BuildingOrAncestor | BuildingOrAncestor[]) =>
      getLevelArea(obj, 0, [RG_TYPE.Core, RG_TYPE.Corridor]),
    PerLevel: getLevelArrayCoreAndCorridorArea,
  },
  RoofArea: {
    Total: getRoofGrossFacadeArea,
    PerLevel: getLevelArrayRoofArea,
  },
  NorthFacingUnits: {
    Total: countNorthFacingUnits,
    PerLevel: getLevelArrayCountNorthFacingUnits,
  },
  PodiumHeightSum: {
    Total: getPodiumHeightSum,
  },
  PodiumLevel: {
    Total: getPodiumLevelCount,
  },
  UnitToLiftCoreRatio: {
    Total: getUnitToLiftCoreRatio,
    PerLevel: getLevelArrayUnitToLiftCoreRatio,
  },
  FacadeInternalCornerLength: {
    Total: getFacadeInternalCornerLength,
  },
  FacadeExternalCornerLength: {
    Total: getFacadeExternalCornerLength,
  },
  ConcreteCO2footprint: {
    Total: getFoundationConcreteWeight,
  },
  SteelCO2footprint: {
    Total: getFoundationSteelWeight,
  },
};
